import { PayloadAction } from "@reduxjs/toolkit";

import { CarsState } from '../../types';

export const updateEBoxLocationsFilter = (
  state: CarsState,
  action: PayloadAction<Partial<CarsState['eBoxLocations']['filter']>>
) => {
  state.eBoxLocations.filter = {
    ...state.eBoxLocations.filter,
    ...action.payload
  }
}
